import { render, staticRenderFns } from "./BaseConfirmPopup.vue?vue&type=template&id=187646b2"
import script from "./BaseConfirmPopup.vue?vue&type=script&lang=js"
export * from "./BaseConfirmPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports